import { STATE } from "../thor.const";

export const getSalesUrl = (isPast: boolean): string => (isPast ? STATE.V2.SALES.PAST : STATE.V2.SALES.FUTURE).url;
